import * as pxp from '../lib/pxp'

/**
 * Treatment:
 * https://www.msmaster.qa.paypal.com/elmo/experiment/114000
 * https://admin.paypalinc.com/elmo/experiment/103368
 *
 *
 * https://engineering.paypalcorp.com/confluence/display/CNSMR/Low+level+design+of+Story+API+implementation
 */

export function is2WayCommentingTrmt() {
  return pxp.isTreatment('Trmt_p2p_social_2way_commenting')
}
